var React = require('react');

function BlueArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_781","data-name":"Path 781","d":"M2886.755,1372.051l4.03,4.03-4.03,4.03","transform":"translate(-2885.755 -1371.051)","fill":"none","stroke":"#abf3e5","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"}));
}

BlueArrow.defaultProps = {"width":"6.03","height":"10.061","viewBox":"0 0 6.03 10.061"};

module.exports = BlueArrow;

BlueArrow.default = BlueArrow;
